import { createFocusTrap } from 'focus-trap';

class Menu {

  constructor(el) {
    this.el     = el;
    this.toggleButton = el.querySelector(".js-menu-toggle");
    this.popup  = el.querySelector(".menu-popup");
    this.backdrop  = el.querySelector(".menu-backdrop");

    this.popup.hidden = true;
    this.backdrop.hidden = true;

    // Create focus trap for the popup
    this.focusTrap = createFocusTrap(this.popup, {
      returnFocusOnDeactivate: true,
      escapeDeactivates: true,
      allowOutsideClick: true,
      initialFocus: () => false,
      clickOutsideDeactivates: (e) => {
        if (this.toggleButton.contains(e.target)) {
          return false;
        }

        return true;
      },
      onDeactivate: () => {
        if (this.isPopupOpen) {
          this.togglePopup(false);
        }
      },
    });

    this.toggleButton.addEventListener("click", (e) => {
      this.togglePopup();
    });
  }

  get isPopupOpen() {
    return this.toggleButton.getAttribute("aria-expanded") === "true";
  }

  togglePopup(force) {
    let oldState = this.isPopupOpen;
    let newState = typeof force === "boolean" ? force : !oldState;
    console.log(oldState, newState);

    if (newState === oldState) {
      return;
    }

    this.toggleButton.setAttribute("aria-expanded", newState.toString());
    this.popup.hidden = !newState;
    this.backdrop.hidden = !newState;

    if (newState) {
      this.focusTrap.activate();
    } else {
      this.focusTrap.deactivate();
    }
  }

}

const menu = document.querySelector(".js-menu");
if (menu) {
  new Menu(menu);
}
